"use strict";

exports.__esModule = true;
exports.getXValueInLinearScale = exports.getXValueFormatterInBandScale = exports.getXValue = exports.getXAxisTimestampBandScale = exports.findClosestXValue = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _constants = require("../../../../Components/Recharts/constants");
var _timeAggregationBinMapping = require("../../../VIMANAMetrics/timeAggregationBinMapping");
var _getTickXFormatter = require("./getTickXFormatter");
var _tooltipUtils = require("./Tooltips/tooltipUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var XValue = function XValue(_ref) {
  var formattedTime = _ref.formattedTime;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: "center",
      padding: "2px"
    }
  }, formattedTime);
};
var getXAxisTimestampBandScale = exports.getXAxisTimestampBandScale = function getXAxisTimestampBandScale(scale, left) {
  var eachBand = scale.step();
  var padding = scale.bandwidth() / 2 + scale.paddingInner() * scale.step() / 2;
  var index = Math.round((left - padding * 1.5) / eachBand);
  var timestamp = scale.domain()[index];
  // Has to be a String to handle hour
  return timestamp !== undefined ? timestamp : "";
};
var getXValue = exports.getXValue = function getXValue(_ref2) {
  var key = _ref2.key,
    tickXFormat = _ref2.tickXFormat;
  if (!key) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(XValue, {
    formattedTime: tickXFormat(key)
  });
};
var getXValueFormatterInBandScale = exports.getXValueFormatterInBandScale = function getXValueFormatterInBandScale(_ref3) {
  var windowType = _ref3.windowType;
  return function (_ref4) {
    var scale = _ref4.scale,
      left = _ref4.left,
      tickXFormat = _ref4.tickXFormat;
    var xAxisTimestamp = getXAxisTimestampBandScale(scale, left);
    if (!xAxisTimestamp) {
      return null;
    }
    if (windowType === _timeAggregationBinMapping.HOUR_PER_DAY) {
      tickXFormat = (0, _getTickXFormatter.getHourXTickFormatter)();
    }
    return /*#__PURE__*/_react["default"].createElement(XValue, {
      formattedTime: tickXFormat(xAxisTimestamp)
    });
  };
};
var findClosestXValue = exports.findClosestXValue = function findClosestXValue(_ref5) {
  var series = _ref5.series,
    timestamp = _ref5.timestamp;
  var getXValue = series.getXValue,
    data = series.data;
  return data.reduce(function (a, item) {
    var key = getXValue && getXValue(item) || item.key || "";
    return Math.abs(key - timestamp) < Math.abs(a - timestamp) ? key : a;
  }, 0);
};
var getXValueInLinearScale = exports.getXValueInLinearScale = function getXValueInLinearScale(_ref6) {
  var scale = _ref6.scale,
    left = _ref6.left,
    timezone = _ref6.timezone,
    series = _ref6.series;
  var timestampMillis = new Date((0, _tooltipUtils.getXAxisTimestampLinearScale)(scale, left)).valueOf();
  var closestX = findClosestXValue({
    series: series[0],
    timestamp: timestampMillis
  });
  return /*#__PURE__*/_react["default"].createElement(XValue, {
    formattedTime: _momentTimezone["default"].utc(closestX).tz(timezone.name).format(_constants.TIMESTAMP_FORMAT)
  });
};